































































































import Vue from 'vue'

import {
  submitQuestionFeedback,
  addQuestionBookmark,
  deleteQuestionBookmark
} from '@/api/question'
import CorrectIcon from '@/components/correct-icon/correct-icon.vue'
import VButton from '@/components/button/basic-button.vue'
import VMarkdown from '@/components/v-markdown/v-markdown.vue'
import FeedbackDialog from '@/components/dialog/feedback-dialog/index.vue'
import ConfirmDialog from '@/components/dialog/confirm-dialog/index.vue'
import Bookmark from '@/components/bookmark/bookmark.vue'
import { isMobile } from '@/lib/helpers/index'

import { indexToLabel, scrollTop } from '@/lib/functions'

interface Data {
  showFeedback: Boolean
  showConfirmFeedback: Boolean
  selectedQuestion?: number | null
  isMobile: Boolean
}
export default Vue.extend({
  name: 'Check',
  data(): Data {
    return {
      isMobile: isMobile(),
      showFeedback: false,
      showConfirmFeedback: false,
      selectedQuestion: null
    }
  },
  props: {
    question: {
      type: Object as Prop<api.unitImpl.Question>,
      required: true
    },
    showSecondSwipeBtn: {
      type: Boolean as Prop<boolean>,
      required: true
    }
  },

  components: {
    CorrectIcon,
    VButton,
    VMarkdown,
    FeedbackDialog,
    ConfirmDialog,
    Bookmark
  },

  mounted() {
    this.$nextTick(() => scrollTop())

    this.$nextTick(() => {
      this.checkShowSecondSwipeBtn()
    })
    window.addEventListener('scroll', this.checkShowSecondSwipeBtn)
  },

  destroyed() {
    window.removeEventListener('scroll', this.checkShowSecondSwipeBtn)
  },

  methods: {
    handleClickClose() {
      this.$emit('close')
    },

    handleSubmitFeedback(v: any) {
      this.selectedQuestion = this.question.id
      if (this.selectedQuestion) {
        submitQuestionFeedback(this.selectedQuestion, v)
        this.showConfirmFeedback = true
      }
    },

    indexToLabel(num: number) {
      return indexToLabel(num)
    },

    handleClickBookmark(bookmarked: boolean) {
      const method = this.question.is_bookmarked
        ? addQuestionBookmark
        : deleteQuestionBookmark
      method(this.question.id).then(() => {
        return 'update bookmark success'
      })
    },

    // 二つ目のスライドボタンを表示するかどうかをチェックする
    checkShowSecondSwipeBtn() {
      const questionsEl = this.$el.querySelector('.questions') as HTMLElement

      if (questionsEl) {
        const rect = questionsEl.getBoundingClientRect()

        const show = rect.bottom < window.innerHeight / 2 - 100
        if (show !== this.showSecondSwipeBtn) {
          this.$emit('updateShowSecondSwipeBtn', show)
        }
      }
    }
  }
})
